import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function ServicesSection() {
  return (
    <section className="w-full py-16 md:py-24 bg-background-50" aria-labelledby="services-title">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="text-center max-w-2xl mx-auto mb-12 md:mb-16">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium tracking-wide uppercase mb-4">
            核心服务
          </span>
          <h2 id="services-title" className="text-2xl md:text-3xl lg:text-4xl font-bold font-heading text-foreground-950 mb-4">
            一站式品牌传播解决方案
          </h2>
          <p className="text-foreground-600 leading-relaxed">
            从策略到创意，从内容到传播，我们提供覆盖品牌全生命周期的专业服务
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6 max-w-6xl mx-auto">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group relative bg-background-100 rounded-xl p-6 md:p-7 border border-background-200/70 hover:border-primary-300/60 hover:shadow-lg transition-all duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-white transition-colors">
                <i className={`${cat.icon} text-xl`} />
              </div>
              <h3 className="text-lg font-semibold font-heading text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                {cat.name}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                {cat.description}
              </p>
              <span className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 group-hover:gap-2 transition-all">
                了解更多
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line" />
                </span>
              </span>
            </Link>
          ))}
          {/* Extra card for full service */}
          <div className="sm:col-span-2 lg:col-span-2 bg-primary-500 rounded-xl p-6 md:p-7 text-white flex flex-col md:flex-row items-start md:items-center gap-4 md:gap-6">
            <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-white/20 flex-shrink-0">
              <i className="ri-stack-line text-xl" />
            </div>
            <div className="flex-1">
              <h3 className="text-lg font-semibold font-heading mb-1">全案整合服务</h3>
              <p className="text-sm text-white/80 leading-relaxed">
                从品牌战略到执行落地，我们提供端到端的整合营销服务，让品牌传播形成合力
              </p>
            </div>
            <Link
              to="/about"
              className="px-5 py-2.5 rounded-full bg-white text-primary-600 text-sm font-medium hover:bg-white/90 transition-colors whitespace-nowrap flex-shrink-0"
            >
              咨询合作
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}